import { lazy } from 'react';

export const ReportsPageCatalogComplianceDrillIn = lazy(
    () => import('./ReportsPageCatalogComplianceDrillIn'),
);
